import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <React.Fragment>
<footer style={{ padding:'4rem 2rem'}} className="footer">
<div className="content has-text-centered">
<p>
<strong>Grocery App</strong> by Daniel Corcoran. Built with React and Bulma CSS.
</p>
</div>
</footer>

            </React.Fragment>
        )
    }
}






